import React from "react";
import { useTranslation } from "react-i18next";
import HeaderNormal from "../components/header/HeaderNormal";
import { Container } from "react-bootstrap";
import TitleSection from "../components/heading/TitleSection";
import PrivacyPolicyContainer from "../components/PrivacyPolicyContainer";
import Footer from "../components/footer/Footer";
import PageSeo from "../components/seo/PageSeo";
import { getPageSeo } from "../seo/siteSeo";

function ProtectionData() {
  const { t, i18n } = useTranslation("common");
  const seo = getPageSeo(i18n.resolvedLanguage || i18n.language, "protectionData");

  return (
    <React.Fragment>
      <PageSeo
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath="/protection-data"
      />

      <HeaderNormal className="background-section text-uppercase" description={t("Politique de confidentialité")}>
        {t("Protection de données")}
      </HeaderNormal>

      <Container className="section-margin">
        <TitleSection description={t("Politique de confidentialité")} />
        <PrivacyPolicyContainer className="section-margin" />
      </Container>

      <Footer />
    </React.Fragment>
  );
}

export default ProtectionData;
